export default __webpack_public_path__ + "eb193a0.png";